import React from 'react';
import { Card } from '@roger/ui-components';
import { Button } from '@roger/ui-components';
import { useStore } from '../../store';

interface UserCardProps {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  title: string;
  onReset: () => void;
  onDeactivate: () => void;
}

export const UserCard: React.FC<UserCardProps> = ({
  firstName,
  lastName,
  username,
  email,
  title,
  onReset,
  onDeactivate,
}) => {
  const showSuccess = useStore(state => state.showSuccess);
  const showError = useStore(state => state.showError);
  const handleCopyEmail = async () => {
    if (email) {
      try {
        await navigator.clipboard.writeText(email);
        showSuccess('Email copied', `${email} copied to clipboard`);
      } catch {
        showError('Failed to copy email');
      }
    }
  };

  return (
    <Card className='p-3 sm:p-3 md:p-3'>
      <div className='flex items-center justify-between gap-2'>
        <div className='flex-1 min-w-0'>
          <p className='text-sm font-medium truncate'>
            {firstName} {lastName}, {title}
          </p>
          <p className='text-xs text-muted-foreground truncate'>({username})</p>
          <p
            className='text-xs text-muted-foreground truncate cursor-pointer hover:text-foreground transition-colors'
            onClick={handleCopyEmail}
            title='Click to copy email'
          >
            {email || 'Email: N/A'}
          </p>
        </div>
        <div className='flex flex-col gap-2 flex-shrink-0'>
          <Button
            size='sm'
            variant='destructive'
            onClick={onDeactivate}
            className='h-6 text-xs px-2'
          >
            Deactivate
          </Button>
          <Button
            size='sm'
            variant='default'
            onClick={onReset}
            className='h-6 text-xs px-2'
          >
            Reset
          </Button>
        </div>
      </div>
    </Card>
  );
};
